import { render, staticRenderFns } from "./Receipt-addProduct.vue?vue&type=template&id=66148601&scoped=true"
import script from "./Receipt-addProduct.vue?vue&type=script&lang=js"
export * from "./Receipt-addProduct.vue?vue&type=script&lang=js"
import style0 from "./Receipt-addProduct.vue?vue&type=style&index=0&id=66148601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66148601",
  null
  
)

export default component.exports